import images from "@assets/images";
import { ButtonIcon } from "@src/components/button";
import React, { useMemo } from "react";
import { Modal, ScrollView, Text, View } from "react-native";
import { SignatureContext } from "../provider/signature";
import DrawSection from "./draw-section";
import useStyles from "./styles.css";
const SigningModal = () => {
  const styles = useStyles();
  const { showSignature, setShowSignature } = React.useContext(SignatureContext);

  const onClose = () => setShowSignature(false);

  const RenderTabItem = useMemo(() => {
    return <DrawSection onClose={onClose} />;
  }, [onClose]);

  return (
    <Modal
      transparent
      visible={showSignature}
      animationType={"none"}
      onRequestClose={onClose}
      supportedOrientations={[
        "portrait",
        "portrait-upside-down",
        "landscape",
        "landscape-left",
        "landscape-right",
      ]}
    >
      <View style={styles.signModalBlurBG}>
        <View style={styles.signContainer}>
          <View style={styles.signHeader}>
            <Text style={styles.signTextHeader}>Add your signature</Text>
          </View>
          <ScrollView>{RenderTabItem}</ScrollView>
        </View>
      </View>
    </Modal>
  );
};

export default SigningModal;
